import type { RevisionChip } from '../../services/calibreLineageLogic';

/**
 * A lineage member's state chip (memo D15): Current in the info colour,
 * Superseded in neutral grey, the placeholder as "Revision unspecified".
 */
export function RevisionChipBadge({ chip }: { chip: RevisionChip }) {
  const cls =
    chip.kind === 'current'
      ? 'bg-blue-100 text-blue-800'
      : chip.kind === 'placeholder'
        ? 'bg-amber-50 text-amber-800 border border-amber-200'
        : 'bg-gray-100 text-gray-600';
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${cls}`}>{chip.label}</span>
  );
}
